export const sortByLocale = (key) => (array) =>
  [...array].sort((a, b) => a[key]?.localeCompare(b[key] || ''));

export const sortByNumber = (key) => (array) =>
  [...array].sort((a, b) => (a[key] ?? 0) - (b[key] ?? 0));
